module.exports = __webpack_public_path__ + "static/img/Nathan-Cleary.deff302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nathan-Cleary.jpg
// module id = VUsT
// module chunks = 0